<template lang="pug">
  v-container.text-center
    v-card-title.justify-center.grey--text
      h4.break-word {{title}}
    v-card-text.text-center.font-weight-light.grey--text
      h5.break-word.mb-2(v-if="description") {{description}}
      h4.break-word TENDER
    //- v-col(cols="12")
      v-img(src='@/assets/logo-2.png' width="200" style="display: block; margin: 0 auto")
      v-col(cols="12")
        v-card-title.justify-center.grey--text
          h4.break-word {{title}}
        v-card-text.text-center.font-weight-light.grey--text
          h5.break-word TENDER
</template>

<script>
  export default {
    props: {
      title: String,
      description: String,
    },
  }
</script>

<style scoped lang="scss">
  .break-word{
    word-break: break-word;
  }
</style>
